import {createMuiTheme, createTheme} from "@material-ui/core";

const Normal = createTheme({
    palette: {
        primary: {
            main: '#616a70',
            contrastText: '#ffffff'
        },
        background: {
            default: '#ffffff'
        },
        text: {
            primary: '#000000'
        }
    }
});

export default Normal;